const eventSelectors = {
  buttons: '[data-event-space-trigger]',
  card: '.event-space',
  cardContents: '.event-space-overlay',
  closeButton: '.event-space-close',
};

const menuSelectors = {
  closeButton: '[data-food-menu-close]',
};

const homepageSelectors = {
  scrollToAnchor: '[data-scroll-to]',
};

const activateEventCard = function(button) {
  let eventCard = button.closest(eventSelectors.card);
  let eventCardContents = eventCard.querySelector(eventSelectors.cardContents);
  let closeButton = eventCard.querySelector(eventSelectors.closeButton);

  if (eventCard) {
    eventCard.classList.add('is-flipped');
    closeButton.addEventListener('click', handleCardClose, false);

    // ARIA
    eventCardContents.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', 'true');
    button.setAttribute('tabindex', '-1');
    closeButton.setAttribute('tabindex', '0');
  }
};

let handleCardClose = function() {
  let closeButton = event.target.closest(eventSelectors.closeButton);
  let eventCard = closeButton.closest(eventSelectors.card);
  let openButton = eventCard.querySelector(eventSelectors.buttons);
  let eventCardContents = eventCard.querySelector(eventSelectors.cardContents);

  if (eventCard) {
    eventCard.classList.remove('is-flipped');
    closeButton.removeEventListener('click', handleCardClose, false);

    // ARIA
    eventCardContents.setAttribute('aria-hidden', 'true');

    setTimeout(function() {
      eventCardContents.focus();
    }, 1000);
    openButton.setAttribute('aria-expanded', 'false');
    openButton.setAttribute('tabindex', '0');
    closeButton.setAttribute('tabindex', '-1');
  }
};

let closeFoodMenu = function(button) {
  let closeButton = button.closest(menuSelectors.closeButton);
  let thisMenuSelector = closeButton.getAttribute('data-target');
  let thisMenu = document.querySelector('#' + thisMenuSelector);
  let accordionToggle = thisMenu.querySelector('.accordion-title');

  if (accordionToggle) {
    accordionToggle.click();
    const scrollPos = thisMenu.offsetTop - (document.getElementById('top-bar-menu').offsetHeight);
    window.scrollTo(0, scrollPos);
  }
};

let scrollToElement = function(target) {
  if (!target) {
    return;
  }

  const scrollPos = target.offsetTop - (document.getElementById('top-bar-menu').offsetHeight);
  window.scrollTo(0, scrollPos);
};

jQuery(document).ready(function() {
  const eventDetailBtns = document.querySelectorAll(eventSelectors.buttons);
  const menuCloseBtns = document.querySelectorAll(menuSelectors.closeButton);
  const scrollToAnchor = document.querySelectorAll(homepageSelectors.scrollToAnchor);

  if (eventDetailBtns.length > 0) {
    for (var i = 0; i < eventDetailBtns.length; i++) {
      eventDetailBtns[i].addEventListener('click', function(event) {
        activateEventCard(event.target);
      });
    }
  }

  if (menuCloseBtns.length > 0) {
    for (let i = 0; i < menuCloseBtns.length; i++) {
      menuCloseBtns[i].addEventListener('click', function(event) {
        closeFoodMenu(event.target);
      });
    }
  }

  if (scrollToAnchor.length > 0) {
    for (let n = 0; n < scrollToAnchor.length; n++) {
      scrollToAnchor[i].addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        const targetSelector = event.target.getAttribute('data-scroll-to');
        const scrollTarget = document.querySelector(targetSelector);
        scrollToElement(scrollTarget);
      });
    }
  }
});
